import React from 'react';
import OfferDetailView from "Routes/Public/Offer/Components/OfferDetail";

const OfferDetail = () => (
    <OfferDetailView />
);

export default OfferDetail;
